import { MKT_ANALYTICS_DESIGN as d } from '../MktAnalytics.design';

const PERIOD_OPTIONS = [
    { value: 'last-7-days', label: 'Últimos 7 dias' },
    { value: 'last-14-days', label: 'Últimos 14 dias' },
    { value: 'last-30-days', label: 'Últimos 30 dias' },
    { value: 'last-90-days', label: 'Últimos 90 dias' },
    { value: 'custom', label: 'Personalizado' }
];

export default function PeriodFilter({ period, onPeriodChange, startDate, endDate, onStartDateChange, onEndDateChange }) {
    return (
        <div className={d.filters.container}>
            <div>
                <label className={d.filters.label}>Período</label>
                <select
                    className={d.filters.select}
                    value={period}
                    onChange={(e) => onPeriodChange(e.target.value)}
                >
                    {PERIOD_OPTIONS.map(opt => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                </select>
            </div>

            {period === 'custom' && (
                <>
                    <div>
                        <label className={d.filters.label}>De</label>
                        <input
                            type="date"
                            className={d.filters.dateInput}
                            value={startDate}
                            onChange={(e) => onStartDateChange(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className={d.filters.label}>Até</label>
                        <input
                            type="date"
                            className={d.filters.dateInput}
                            value={endDate}
                            onChange={(e) => onEndDateChange(e.target.value)}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
